import React from 'react';
import { Tooltip, Paper } from '@material-ui/core';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

const DashboardDesktopHeaderActions = ({
  classes,
  urlArray,
  showLanguages,
  displayLanguages,
  handleLanguageChange,
  userData,
  setLogOut,
  user_admin,
  translate
}) => {
  return (
    <>
      <div style={{ position: 'relative' }} onClick={displayLanguages}>
        <img
          className={classes.appBarToolbarLanguage}
          src={urlArray[1] === 'se' ? '/se.png' : '/gb.png'}
          alt="language"
        />

        {showLanguages && (
          <Paper className={classes.appToolbarLanguagePaper}>
            {urlArray[1] === 'se' && (
              <img
                className={classes.appBarToolbarLanguage}
                src="/gb.png"
                alt="en"
                onClick={() => handleLanguageChange({ lang: 'en', code: 'en-US' })}
              />
            )}
            {urlArray[1] === 'en' && (
              <img
                className={classes.appBarToolbarLanguage}
                src="/se.png"
                alt="se"
                onClick={() => handleLanguageChange({ lang: 'se', code: 'sv-SE' })}
              />
            )}
          </Paper>
        )}
      </div>

      <img className={classes.appBarToolbarUserIcon} src="/user.png" alt="user" />
      <span className={classes.appBarToolbarUserName}>
        {userData.name || userData.email}
      </span>
      <Tooltip title={translate('', 'tooltip_logout')} onClick={() => setLogOut({ user_admin })}>
        <PowerSettingsNewIcon className={classes.appBarToolbarLogout} />
      </Tooltip>
    </>
  );
};

export default DashboardDesktopHeaderActions;